<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.professional-status' | translate }}:
            </h3>
            <mat-radio-group name="fdtnpActivityWithIncome" [(ngModel)]="activityExist" [required]="true"
            [disabled]="isDisabled" (ngModelChange)="onActivityChange($event)">
            <div class="row">
                <div class="col-12 col-md-6 order-1">
                    <mat-radio-button class="mb-3 mb-sm-4" color="blue-gray"  name="fdtnpActivityWithIncome1"
                        [value]="false">
                        {{ 'form.situation.activity-with-income' | translate }}
                    </mat-radio-button>
                </div>
                <div class="col-12 col-md-6 order-1">
                    <mat-radio-button class="mb-3 mb-sm-4" color="blue-gray" name="fdtnpActivityWithIncome2"
                        [value]="true">
                        {{ 'form.situation.activity-without-income' | translate }}
                    </mat-radio-button>
                </div>
            </div>

        </mat-radio-group>
            <mat-radio-group name="fdtnpSituation" id="fdtnpSituation" [(ngModel)]="client.professional.employmentSituation"
                (ngModelChange)="cleanForm()" [required]="!!client.professional.employmentSituation" [disabled]="isDisabled">
                <div class="row" *ngIf="showActivity && !showActivityIncomeNo">
                    <div class="col-12">
                        <h3 class="mat-subheading-1 text-blue font-weight-bold">
                            <span class="pl-30"></span>
                            {{ 'form.situation.activity-with-income-title' | translate }}:
                        </h3>
                    </div>
                    <div class="col-12 col-md-6 order-1 pl-40">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpAsEmployee" color="blue-gray"
                            [value]="EmploymentSituation.AS_EMPLOYEE">
                            {{ 'form.situation.as-employee' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-md-6 order-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSelfEmployed" color="blue-gray"
                            [value]="EmploymentSituation.SELF_EMPLOYED">
                            {{ 'form.situation.self-employed' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-md-6 order-5 pl-40">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpPension" color="blue-gray"
                            [value]="EmploymentSituation.PENSION">
                            {{ 'form.situation.pension' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-md-6 order-6">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpUnemployment" color="blue-gray"
                            [value]="EmploymentSituation.UNEMPLOYMENT">
                            {{ 'form.situation.unemployment' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-md-6 order-6 pl-40">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpRents" color="blue-gray"
                            [value]="EmploymentSituation.RENTS">
                            {{ 'form.situation.rents' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row pl-30">
                <div class="col-12 col-md-6 order-md-4"
                    [class.order-2]="client.professional.employmentSituation === EmploymentSituation.AS_EMPLOYEE"
                    [class.order-4]="client.professional.employmentSituation === EmploymentSituation.SELF_EMPLOYED"
                    *ngIf="isEmployeeOrSelfEmployed && !showActivityIncomeNo">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdtnpCompanyName" matInput [placeholder]="'form.name-company' | translate" required
                            [disabled]="isDisabled" [(ngModel)]="client.professional.companyName"
                            #companyName="ngModel" />
                        <mat-error *ngIf="companyName.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 order-md-4"
                    [class.order-2]="client.professional.employmentSituation === EmploymentSituation.AS_EMPLOYEE"
                    [class.order-4]="client.professional.employmentSituation === EmploymentSituation.SELF_EMPLOYED"
                    *ngIf="isEmployeeOrSelfEmployed && !showActivityIncomeNo">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdtnpCompanyActivity" matInput [placeholder]="'form.company-activity' | translate"
                            required [disabled]="isDisabled" [(ngModel)]="client.professional.companyActivity"
                            #companyActivity="ngModel" />
                        <mat-error *ngIf="companyActivity.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <mat-radio-group name="fdtnpActivityWithoutIncomeSource" id="fdtnpActivityWithoutIncomeSource" [(ngModel)]="client.professional.activityWithoutIncome"
                (ngModelChange)="cleanForm()" [required]="!!client.professional.activityWithoutIncome" [disabled]="isDisabled">
                <div class="col-12">
                    <div class="row" *ngIf="showActivity && (showActivityIncomeNo || !!client.professional.activityWithoutIncome)">
                        <div class="col-12 pl-30">
                            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                               {{ 'form.situation.activity-without-income-title' | translate }}:
                            </h3>
                        </div>
                        <div class="col-12 col-md-6 order-1 pl-25">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpMinor" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.MINOR">
                                {{ 'form.situation.minor' | translate }}
                            </mat-radio-button>
                        </div>
                        <div class="col-12 col-md-6 order-2">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpStudent" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.STUDENT">
                                {{ 'form.situation.student' | translate }}
                            </mat-radio-button>
                        </div>
                        <div class="col-12 col-md-6 order-3 pl-25">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpUWhithoutBenefit" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.UNEMPLOYEMENT_WITHOUT_BENEFIT">
                                {{ 'form.situation.unemployment-without-benefit' | translate }}
                            </mat-radio-button>
                        </div>
                        <div class="col-12 col-md-6 order-4">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpHousewife" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.HOUSEWIFE">
                                {{ 'form.situation.housewife' | translate }}
                            </mat-radio-button>
                        </div>
                        <div class="col-12 col-md-6 order-5 pl-25">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpCoOwner" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.ACTIVITY_OF_COOWNER">
                                {{ 'form.situation.activity-co-owner' | translate }}
                            </mat-radio-button>
                        </div>
                        <div class="col-12 col-md-6 order-6">
                            <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpOthers" color="blue-gray"
                                [value]="ActivityWithoutIncomeSource.OTHERS">
                                {{ 'form.situation.others' | translate }}
                            </mat-radio-button>
                        </div>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row justify-content-end">
            <div class="col-12 col-md-6 order-md-4" *ngIf="client.professional.activityWithoutIncome === ActivityWithoutIncomeSource.OTHERS && showActivity && showActivityIncomeNo">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdtnpActivityWithoutIncomeOthers" matInput required [placeholder]="'form.situation.othersText' | translate"
                            [disabled]="isDisabled" [(ngModel)]="client.professional.activityWithoutIncomeOthers"
                            #activityWithoutIncomeOthers="ngModel" />
                        <mat-error *ngIf="activityWithoutIncomeOthers.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field></div>
                </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.professional-position' | translate }}
            </h3>
            <div class="col-12 order-1">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="fdtnpPosition" matInput [placeholder]="'form.professional-position' | translate"
                        required  [matAutocomplete]="professionalGroup" [(ngModel)]="position"
                        (ngModelChange)="onPositionChange()" #positionCtrl="ngModel" [disabled]="isDisabled" />
                    <mat-autocomplete #professionalGroup="matAutocomplete">
                        <mat-option *ngFor="let position of positionsFiltered | async" [value]="position">
                            {{ position.code }} - {{ position.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="positionCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div><!--cierro fila-->

        <div class="col-12 pl-30"
            [class.order-2]="client.professional.employmentSituation === EmploymentSituation.AS_EMPLOYEE"
            [class.order-4]="client.professional.employmentSituation === EmploymentSituation.SELF_EMPLOYED"
            >
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.professional-other-position' | translate }}
            </h3>
            <mat-radio-group name="fdtnpOtherActivity" [(ngModel)]="client.professional.hasRiskActivity"
                (ngModelChange)="onOtherActivityChange($event)" [required]="true" [disabled]="isDisabled || !isEmployeeOrSelfEmployed || showActivityIncomeNo">
                <div class="row">
                    <div class="col-12 col-md-6 order-1">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpOtherActivity" color="blue-gray"
                            [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-md-6 order-1">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpOtherActivity" color="blue-gray"
                            [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row">
                <mat-radio-group id="fdtnpOtherActivitySource" name="fdtnpOtherActivitySource" [(ngModel)]="client.professional.riskActivityCode"
                    [required]="client.professional.hasRiskActivity" [disabled]="!client.professional.hasRiskActivity || isDisabled || !isEmployeeOrSelfEmployed">
                    <div class="col-12" *ngFor="let otherPosition of otherPositions">
                        <mat-radio-button class="mb-3 mb-sm-4" color="blue-gray" [name]="'fdtnpOtherActivitySourcep' + otherPosition.id"
                            [value]="client.professional.riskActivityCode === '' + otherPosition.id ? client.professional.riskActivityCode : otherPosition.id"
>                            {{otherPosition.name}}
                        </mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
        </div>
        <!--cierro fila-->
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.employment-relationship' | translate }}
            </h3>
            <mat-radio-group name="fdtnpContractualTime" [(ngModel)]="client.professional.contractualTime"
                [required]="true" [disabled]="isDisabled || !isEmployeeOrSelfEmployed">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpLess1" color="blue-gray"
                            [value]="ContractualTime.LESS_1_YEAR">
                            {{ 'form.contractual-time.less-1' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpBetween15" color="blue-gray"
                            [value]="ContractualTime.BETWEEN_1_5_YEARS">
                            {{ 'form.contractual-time.between-1-5' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpBetween510" color="blue-gray"
                            [value]="ContractualTime.BETWEEN_5_10_YEARS">
                            {{ 'form.contractual-time.between-5-10' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpMore10" color="blue-gray"
                            [value]="ContractualTime.MORE_10_YEARS">
                            {{ 'form.contractual-time.more-10' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.want-include-clarifications' | translate }}
            </h3>
            <mat-radio-group name="fdtnpYesNo" [(ngModel)]="client.professional.isMultiplesActivities"
                (ngModelChange)="onYesNoChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdtnpNo" class="mb-3 mb-sm-4" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdtnpYes" class="mb-3 mb-sm-4" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row justify-content-end" *ngIf="client.professional.isMultiplesActivities">
                <div class="col-12 col-sm-9">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdtnpAdditionalActivitiesInfo" matInput
                            [placeholder]="'form.additional-activities' | translate" required [disabled]="isDisabled"
                            [(ngModel)]="client.professional.additionalActivitiesInfo"
                            #additionalActivities="ngModel" />
                        <mat-error *ngIf="additionalActivities.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.source-of-income' | translate }}:
            </h3>
            <mat-radio-group name="fdtnpSourceIncome" [(ngModel)]="client.professional.sourceOfIncome"
                (ngModelChange)="onResize()" [required]="true" [disabled]="isDisabled || showActivityIncomeNo || showActivityIncomeNo === undefined || isEmployeeOrSelfEmployed">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSIWork" color="blue-gray"
                            [value]="SourceIncome.WORK"
                            [disabled]="client.professional.employmentSituation === EmploymentSituation.UNPAID_ACTIVITY || !salary">
                            {{ 'form.source-income.work' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSICapitalRents" color="blue-gray"
                            [value]="SourceIncome.CAPITAL_RENTS">
                            {{ 'form.source-income.capital-rents' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSINone" color="blue-gray"
                            [value]="SourceIncome.NONE">
                            {{ 'form.source-income.none' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSIPublicBenefits" color="blue-gray"
                            [value]="SourceIncome.PUBLIC_BENEFITS">
                            {{ 'form.source-income.public-benefits' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSIPension" color="blue-gray"
                            [value]="SourceIncome.PENSION">
                            {{ 'form.source-income.pension' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtSIOther" color="blue-gray"
                            [value]="SourceIncome.OTHER">
                            {{ 'form.source-income.other' | translate }}
                        </mat-radio-button>
                        <mat-form-field class="full-width mb-3 mb-sm-4"
                            *ngIf="client.professional.sourceOfIncome === SourceIncome.OTHER">
                            <input name="fdtnpSourceIncomeOther" matInput
                                [placeholder]="'form.other-source-income' | translate" required [disabled]="isDisabled"
                                [(ngModel)]="client.professional.sourceOfIncomeFreeText"
                                #sourceOfIncomeFreeText="ngModel" />
                            <mat-error *ngIf="sourceOfIncomeFreeText.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.source-of-funds' | translate }}:
            </h3>
            <mat-radio-group name="fdtnpSourceFunds" [(ngModel)]="client.professional.sourceOfFunds"
                (ngModelChange)="onSourceFundsChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSFWork" color="blue-gray"
                            [value]="SourceFunds.SALARIES"
                            [disabled]="client.professional.employmentSituation === EmploymentSituation.UNPAID_ACTIVITY">
                            {{ 'form.source-funds.salaries' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSFHeritage" color="blue-gray"
                            [value]="SourceFunds.HERITAGE">
                            {{ 'form.source-funds.savings' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSFInheritance" color="blue-gray"
                            [value]="SourceFunds.INHERITANCE_OR_SAVINGS">
                            {{ 'form.source-funds.inheritance' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSFRealEstateSales" color="blue-gray"
                            [value]="SourceFunds.REAL_ESTATE_SALES">
                            {{ 'form.source-funds.real-estate-sales' | translate }}
                        </mat-radio-button>
                    </div>

                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpSFOther" color="blue-gray"
                            [value]="SourceFunds.OTHER">
                            {{ 'form.source-funds.other' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <mat-form-field class="full-width mb-3 mb-sm-4"
                *ngIf="client.professional.sourceOfFunds === SourceFunds.OTHER">
                <input name="fdtnpSourceFundsOther" matInput [placeholder]="'form.other-source-funds' | translate"
                    required [disabled]="isDisabled" [(ngModel)]="client.professional.sourceOfFundsFreeText"
                    #sourceOfFundsFreeText="ngModel" />
                <mat-error *ngIf="sourceOfFundsFreeText.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span>
                {{ 'full-data.annual-net' | translate }}:
            </h3>
            <mat-radio-group name="fdtnpAnnualNet" [(ngModel)]="client.professional.annualNetIncome" [required]="true"
                [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpANLess30000" color="blue-gray"
                            [value]="AnnualNetIncome.LESS_30000">
                            {{ 'form.annual-net.less-30000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpANBetween3000160000" color="blue-gray"
                            [value]="AnnualNetIncome.BETWEEN_30001_60000">
                            {{ 'form.annual-net.between-30001-60000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpANBetween60001100000" color="blue-gray"
                            [value]="AnnualNetIncome.BETWEEN_60001_100000">
                            {{ 'form.annual-net.between-60001-100000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpANBetween100001150000" color="blue-gray"
                            [value]="AnnualNetIncome.BETWEEN_100001_150000">
                            {{ 'form.annual-net.between-100001-150000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpANMore150000" color="blue-gray"
                            [value]="AnnualNetIncome.MORE_150000">
                            {{ 'form.annual-net.more-150000' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled && !isDisabledSubmit">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue"
                [disabled]="!isFormValid">
                {{ 'general.save' | translate }}
            </button>
        </div>
    </div>
</ng-container>
